var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGhostFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20.000000pt",
    height: "20.000000pt",
    viewBox: "0 0 96.000000 96.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,96.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400 887 c-19 -6 -58 -34 -85 -62 -52 -51 -75 -102 -75 -164 0 -38 -5 -38 -52 -6 -46 31 -78 32 -106 2 -36 -38 -29 -71 30 -130 29 -29 64 -60 78 -69 l25 -16 -48 -93 c-26 -52 -47 -100 -47 -106 0 -7 16 -31 36 -53 26 -29 51 -44 92 -56 32 -9 80 -28 107 -43 72 -37 179 -37 250 1 28 14 75 33 107 42 41 12 65 27 92 56 20 22 36 46 36 53 0 6 -21 54 -47 106 l-48 93 25 16 c14 9 49 40 78 69 59 60 67 95 29 131 -30 29 -60 28 -105 -3 -47 -32 -52 -32 -52 6 0 56 -23 110 -67 159 -65 72 -158 97 -253 67z m32 -232 c15 -33 -3 -75 -32 -75 -29 0 -47 42 -32 75 7 15 20 25 32 25 12 0 25 -10 32 -25z m160 0 c15 -33 -3 -75 -32 -75 -29 0 -47 42 -32 75 7 15 20 25 32 25 12 0 25 -10 32 -25z m-56 -140 c39 -39 27 -50 -56 -50 -83 0 -95 11 -56 50 16 16 36 25 56 25 20 0 40 -9 56 -25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhostFilled);
export default __webpack_public_path__ + "static/media/ghostFilled.067d4821.svg";
export { ForwardRef as ReactComponent };